import {h, Component} from 'preact'
import util from '../util';

export default class BorderWidget extends Component {
    constructor() {
        super()

        this.getBorderCss = () => {
            const $element = this.props.$element;
            if (!$element) return;
            let borderObject = util.getBorderElement($element);
            return borderObject.css('border-color');
        }
    }

    render(props, state) {
        return (
            <div className="dropdown sizes">
                <a className="dropdown-toggle car">
                    <span>Border</span>
                </a>
                <div className="dropdown-menu auto image-border-widget" data-close="no" style="overflow-y: unset;">
                    <ul className="slider-list">
                        <li className="color-item">
                            <div className="border-color">
                                <label>Color</label>
                                <div onClick={() => this.props.openColorPicker()}>
                                    <span className="color-box" style={`background: ${this.getBorderCss()}; float: none;`}></span>
                                </div>
                            </div>

                            <div className={ '' + this.props.withNoBorder === 'true' ? '' : ' hidden'}>
                                <a className="remove custom-clear" onClick={ props.onClearBorder }>
                                    <span className="no-fill" />
                                    <small className="txt">clear</small>
                                </a>
                            </div>
                        </li>

                        <li className="slider-item">
                            <div className={'slider-wrap'}>
                                <label>Width</label>
                                <div className="toolbar-wrap">
                                    <input className="slider" type="range" min="0" max="25" step="1" value={ props.width } onChange={ props.onWidthUpdate } onMouseMove={props.onWidthUpdate} />
                                </div>
                                <input className="value" type="number" min="0" max="25" step="1" disabled="disabled" value={props.width} />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}
